// 이 파일은 원보카 개인정보처리방침(영어) 원문을 그대로 옮긴 것입니다.
// 내용을 수정할 때에는 법무 검토를 거친 원문과 반드시 함께 갱신해 주세요.

import { PolicyBlock } from "./PolicyBlock";

const privacyPolicyEn: PolicyBlock[] = [
  {
    "kind": "heading",
    "text": "Article 1: Purpose of Processing Personal Information"
  },
  {
    "kind": "paragraph",
    "text": "The company processes personal information for the following purposes. The personal information being processed will not be used for any purpose other than the following. If the purpose of use changes, necessary measures such as obtaining separate consent will be taken in accordance with Article 18 of the Personal Information Protection Act."
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "Membership registration and management",
        "children": [
          {
            "text": "Personal information is processed for the purposes of identification and authentication, maintaining membership, and management."
          }
        ]
      },
      {
        "text": "Provision of services",
        "children": [
          {
            "text": "Personal information is processed for the purpose of providing services."
          }
        ]
      }
    ]
  },
  {
    "kind": "heading",
    "text": "Article 2: Processing and Retention Period of Personal Information"
  },
  {
    "kind": "paragraph",
    "text": "The company processes and retains personal information within the period of retention and use of personal information consented to by the information subject at the time of collection or as prescribed by law. The processing and retention period for each personal information is as follows:"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "Membership registration and management",
        "children": [
          {
            "text": "Data is retained until the account is deleted or the service is terminated to provide continuous service."
          }
        ]
      },
      {
        "text": "Provision of services",
        "children": [
          {
            "text": "Data is retained until the account is deleted or the service is terminated to provide continuous service."
          }
        ]
      }
    ]
  },
  {
    "kind": "heading",
    "text": "Article 3: Items of Personal Information Processed"
  },
  {
    "kind": "paragraph",
    "text": "The company processes the following personal information items:"
  },
  {
    "kind": "list",
    "ordered": false,
    "items": [
      {
        "text": "Required items: Email, login ID, service usage records, access logs, payment records."
      },
      {
        "text": "Optional items: When logging in with 'Apple Login', users can choose whether to provide their email."
      }
    ]
  },
  {
    "kind": "paragraph",
    "text": "Users can delete their personal information at any time using the account deletion feature within the app. Deleting an account within the app permanently deletes all data registered during sign-up and app usage in an irrecoverable manner."
  },
  {
    "kind": "paragraph",
    "text": "Users can delete their account by following this method:"
  },
  {
    "kind": "list",
    "ordered": false,
    "items": [
      {
        "text": "In-app settings → My profile → Click the delete account button."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "Article 4: Procedures and Methods for Destruction of Personal Information"
  },
  {
    "kind": "paragraph",
    "text": "The company immediately destroys personal information when it is no longer necessary, such as when the retention period has expired or the purpose has been achieved."
  },
  {
    "kind": "paragraph",
    "text": "The procedures and methods for personal information destruction are as follows:"
  },
  {
    "kind": "list",
    "ordered": false,
    "items": [
      {
        "text": "Wonvoca selects personal information that has become subject to destruction and destroys it with the approval of Wonvoca's personal information protection officer."
      },
      {
        "text": "Electronic file format information is destroyed using technical methods that prevent record recovery."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "Article 5: Measures Regarding the Destruction of Personal Information of Inactive Users"
  },
  {
    "kind": "paragraph",
    "text": "The company destroys the information of users who have not used the service for 3 years. However, other users' personal information can be stored and managed separately until the preservation period specified by other laws expires."
  },
  {
    "kind": "heading",
    "text": "Article 6: Rights, Obligations, and Methods of Exercise of Information Subjects and Legal Representatives"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "Information subjects can exercise their rights to request access, correction, deletion, and suspension of processing of personal information at any time."
      },
      {
        "text": "The exercise of rights pursuant to Paragraph 1 can be done through written, email, or fax in accordance with Article 41, Paragraph 1 of the Enforcement Decree of the Personal Information Protection Act, and the company will take action without delay."
      },
      {
        "text": "Rights exercise can be done through a representative, such as a legal representative or a delegated person. In this case, a power of attorney in accordance with the form in Annex No. 11 of the Notification on Personal Information Processing Method (No. 2020-7) must be submitted."
      },
      {
        "text": "The request for access and suspension of processing of personal information may be restricted under Article 35, Paragraph 4, and Article 37, Paragraph 2 of the Personal Information Protection Act."
      },
      {
        "text": "Requests for correction and deletion of personal information cannot be made if the personal information is specified as a collection subject in other laws."
      },
      {
        "text": "The company verifies whether the requester is the person or a legitimate representative when requesting access, correction, deletion, or suspension of processing."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "Article 7: Measures to Ensure the Security of Personal Information"
  },
  {
    "kind": "paragraph",
    "text": "The company takes the following measures to ensure the security of personal information:"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "The company installs security programs to prevent leakage and damage of personal information due to hacking or computer viruses, conducts regular updates and inspections, and installs systems in areas controlled from external access, technically and physically monitoring and blocking."
      },
      {
        "text": "The company does not collect users' passwords, so only the users know their passwords. Important data is protected using separate security functions such as encrypting files and transmission data."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "Article 8: Installation, Operation, and Rejection of Automatic Personal Information Collection Devices"
  },
  {
    "kind": "paragraph",
    "text": "The company does not use 'cookies' that store and retrieve users' information from time to time."
  },
  {
    "kind": "heading",
    "text": "Article 9: Collection, Use, Provision, and Refusal of Behavioral Information"
  },
  {
    "kind": "paragraph",
    "text": "\"The company uses user behavioral information for app usability improvements and new feature development, and behavioral information is not collected without the user's consent.”"
  },
  {
    "kind": "heading",
    "text": "Article 10: Personal Information Protection Officer"
  },
  {
    "kind": "paragraph",
    "text": "The company has designated the following personal information protection officer to be responsible for the overall personal information processing tasks, complaint handling, and damage relief related to personal information processing:"
  },
  {
    "kind": "list",
    "ordered": false,
    "items": [
      {
        "text": "Personal Information Protection Officer",
        "children": [
          {
            "text": "Name: Minsu Kim"
          },
          {
            "text": "Position: Representative"
          }
        ]
      },
      {
        "text": "Personal Information Protection Manager",
        "children": [
          {
            "text": "Name: Minsu Kim"
          },
          {
            "text": "Position: Representative"
          }
        ]
      },
      {
        "text": "Department Email: zak1ller.kr@gmail.com"
      }
    ]
  },
  {
    "kind": "paragraph",
    "text": "For reports or consultations needed for other personal information infringements, you can inquire below:"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "Personal Information Dispute Mediation Committee: 1833-6972 (www.kopico.go.kr)"
      },
      {
        "text": "Personal Information Infringement Report Center: 118 (privacy.kisa.or.kr)"
      },
      {
        "text": "Supreme Prosecutors' Office: 1301 (www.spo.go.kr)"
      },
      {
        "text": "National Police Agency: 182 (ecrm.cyber.go.kr)"
      }
    ]
  },
  {
    "kind": "paragraph",
    "text": "This personal information processing policy will be applied from June 13, 2022."
  }
];

export default privacyPolicyEn;
